import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CursorIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M53.7593648,77.0070117 L79.7238802,6.13287899 C80.3318789,4.47116829 79.9170226,2.58888664 78.6644539,1.33746077 L78.6255968,1.29746086 C77.3695996,0.0746063541 75.5067464,-0.325392782 73.8724643,0.275748777 L2.99604586,26.241407 C1.30119237,26.8608342 0.129766332,28.4254023 0.00976659072,30.2265413 C-0.107947441,32.0253945 0.846336213,33.7305337 2.44404705,34.569389 L21.6897198,44.6756529 L2.25433317,64.1098967 C0.476051298,65.8881785 0.477194153,68.7853151 2.25661888,70.5647399 L9.24746093,77.5555819 C10.9720286,79.2801496 13.9788793,79.2801496 15.7045898,77.5555819 L35.1959763,58.0641954 L45.4325257,77.5590105 C46.2233811,79.0641501 47.7719492,80.0001481 49.4736598,80.0001481 C49.5730881,80.0001481 49.6725165,79.9967195 49.7810877,79.9898624 C51.5765124,79.8698626 53.1399376,78.6995795 53.7593648,77.0070117"
      />
    </Icon>
  );
};

CursorIcon.propTypes = {
  fill: PropTypes.string,
};

export default CursorIcon;
